/* eslint-disable react/no-unknown-property */

import { h } from 'preact';

import './InactivePage.css';

export default function InactivePage({ message }) {
  return (
    <div className="beans-inactive-placeholder-container">
      <svg width="96px" height="96px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g id="SVGRepo_bgCarrier" stroke-width="0" />
        <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" />
        <g id="SVGRepo_iconCarrier">
          <path
            d="M3 9.22843V14.7716C3 15.302 3.21071 15.8107 3.58579 16.1858L7.81421 20.4142C8.18929 20.7893 8.69799 21 9.22843 21H14.7716C15.302 21 15.8107 20.7893 16.1858 20.4142L20.4142 16.1858C20.7893 15.8107 21 15.302 21 14.7716V9.22843C21 8.69799 20.7893 8.18929 20.4142 7.81421L16.1858 3.58579C15.8107 3.21071 15.302 3 14.7716 3H9.22843C8.69799 3 8.18929 3.21071 7.81421 3.58579L3.58579 7.81421C3.21071 8.18929 3 8.69799 3 9.22843Z"
            stroke="#323232"
            stroke-width="1.49"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path d="M12 8V13" stroke="#323232" stroke-width="1.49" stroke-linecap="round" />
          <path d="M12 16V15.9888" stroke="#323232" stroke-width="1.49" stroke-linecap="round" />
        </g>
      </svg>
      <div className="beans-inactive-placeholder-text">{message}</div>
    </div>
  );
}
